export default {
  queryPointSourceDetail: '/courier-sqp-api/h5/v1/queryPointSourceDetail'
}
